module.exports = __webpack_public_path__ + "assets/images/starter-kit-label.png";